<template>
	<div>
		<div class="cover-layer invisible" :style="{'position': dom ? 'absolute' : 'fixed'}"></div>
		<div class="c-loading flex-center an an-fadein" :class="{'an-fadeout': end}" :style="{'position': dom ? 'absolute' : 'fixed'}">
			<i class="tf tf-loading tf-spin"></i>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'loading',
		
		data() {
			return {
                dom: '',
				end: false,
				timeout: 10000
			}
		},

		created() {
			this.$loadOver();
			window.$loadingObj = this;
			this.timeout && setTimeout(() => {
				this.close();
			}, this.timeout);
		},

		methods: {
			close() {
				this.end = true;
				setTimeout(() => {
					this.$destroy();
					this.$el.remove();
				}, 250);
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-loading {
		z-index: 9999;
		left: 50%;
		top: 50%;
		width: 50px;
		height: 50px;
		border-radius: 4px;
		font-size: 30px;
		color: #fff;
		background: rgba(0,0,0,.7);
		transform: translate(-50%, -50%);
	}
</style>
